import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import CalculateCFTLayer from "../components/CalculateCFTLayer";

export const CalculateCFTPage = () => {
  return (
    <MasterLayout>
        <CalculateCFTLayer/>
    </MasterLayout>
  );
};
